import React from "react";
import style from "./panel-toolbar.module.css";

export function Toolbar({
  onDismiss,
  showBackButton,
  onBackButtonClick,
}: {
  onDismiss: () => void;
  showBackButton: boolean;
  onBackButtonClick: () => void;
}) {
  return (
    <div role="toolbar" className={style.toolbar}>
      {showBackButton && (
        <button className={style.toolbarButton} onClick={onBackButtonClick}>
          <svg width="18" height="14" viewBox="-1 -1 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path stroke="currentColor" strokeWidth="2px" d="M 7 1 L 1 6 L 7 11 M 1 6 L 17 6" />
          </svg>
        </button>
      )}
      <div className="spacer" />
      <button className={style.toolbarButton} onClick={onDismiss} data-testid="close-voting-button">
        {"\u2715"}
      </button>
    </div>
  );
}
